// extracted by mini-css-extract-plugin
export default {"vehicleImage":"HeroVehicleImage__vehicleImage-zmGl"};